import React from 'react';
import VirtualKeyboard from 'react-virtual-keyboard';
import './Keyboard.scss';

const Keyboard = ({
  code, onChange, onAccepted,
}) => (
  <VirtualKeyboard
    qa-id="keyboard"
    value={code}
    name="keyboard"
    options={{
      beforeInsert(e, keyboard, el, txt) {
        if (txt === '\b') {
          return txt;
        }
        return el.value.length < 8 ? txt : false;
      },
      layout: 'custom',
      customLayout: {
        normal: [
          '1 2 3 4 5 6 7 8 9 0',
          'Q W E R T Y U I O P {bksp}',
          'A S D F G H J K L {accept}',
          'Z X C V B N M',
        ],
      },
      alwaysOpen: true,
      usePreview: false,
      useWheel: false,
      stickyShift: false,
      appendLocally: true,
      position: 'fixed',
      color: 'light',
      lockInput: true,
      updateOnChange: true,
      initialFocus: true,
      display: {
        bksp: ' ',
        accept: ' ',
      },
    }}
    onChange={onChange}
    onAccepted={onAccepted}
  />
);

export default Keyboard;
